import React, { Component } from 'react';
import './Treemap.css';
import * as d3 from 'd3';

const categories = {sydney: ["Humanitarian", "Family", "Economic", "Other"],
    auckland: ["Residence","Student","Work","Visitor","Other","Unknown"],
    vancouver: ["Humanitarian", "Family", "Economic", "Other"]}

const minyear = {sydney: 1991, auckland: 1980, vancouver: 1980}
const maxyear = {sydney: 2018, auckland: 2018, vancouver: 2018}
const maxvalue = {sydney: 276875, vancouver: 285000, auckland: 140000}

class StackedArea extends Component {
    constructor(props) {
        super(props);
        
        this.state = {};

        d3.json("data/national/" + this.props.city + "/timeseries.json").then((data) => {
            this.setState({data: data});
        });
    }

    componentDidMount() {
        this.createStackedArea();
    }

    shouldComponentUpdate(newProps, newState) {
        if (newProps.city !== this.props.city) {
            delete this.areas;
            delete this.categories;
            delete this.state.data;
            d3.select(this.node).selectAll("g").remove();
            d3.json("data/national/" + newProps.city + "/timeseries.json").then((data) => {
                data = data.map((d) => {return {...d, Unknown: Math.max(0, d.Unknown)}});
                this.setState({data: data});
            });
            return false;
        }

        if (categories[this.props.city].indexOf(this.props.category) < 0 || minyear[this.props.city] > this.props.year || maxyear[this.props.city] <= this.props.year) {
            if (minyear[this.props.city] > this.props.year) {
                this.props.update({category: this.props.category, year: minyear[this.props.city]});
                return false;
            }
            if (maxyear[this.props.city] <= this.props.year) {
                this.props.update({category: this.props.category, year: maxyear[this.props.city] - 1});
                return false;
            }

            this.props.update({category: categories[this.props.city][0], year: this.props.year});
            return false;
        }

        return true;
    }

    componentDidUpdate() {
        if (this.areas) {
            this.updateStackedArea();
        } else {
            this.createStackedArea();
        }
    }

    handleMouseClick(e) {
        this.props.update({category: e.key, year: Math.round((e[0].data.year + e[1].data.year)/2)});
    }

    updateStackedArea() {
        const height = this.props.height;
        const width = this.props.width;
        var fader = function(color) { return d3.interpolateRgb(color, "#fff")(0.1); };

        let scheme = d3.scaleOrdinal([d3.interpolateViridis(0.45), d3.interpolateViridis(0.525), d3.interpolateViridis(0.6), d3.interpolateViridis(0.7), d3.interpolateViridis(0.775), d3.interpolateViridis(0.775)].map(fader));

        let margin = {top: 20, right: 0, bottom: 30, left: 50};

        const yScale = d3.scaleLinear().domain([0, maxvalue[this.props.city]]).range([height - margin.top - margin.bottom, 0]);
        const xScale = d3.scaleLinear().domain([minyear[this.props.city], maxyear[this.props.city]-1]).range([0, width - margin.left - margin.right]);
        
        let area = d3.area()
            .x((d) => xScale(d.data.year))
            .y0((d) => yScale(d[0]))
            .y1((d) => yScale(d[1]));

        let line = d3.line()
            .x((d) => xScale(d.data.year))
            .y((d) => yScale(d[1]));

        for (let year = minyear[this.props.city]; year < maxyear[this.props.city]; year++) {
            this.areas[year].attr("d", area).style("fill", (d) => {
                let year = Math.round((d[0].data.year + d[1].data.year)/2);
                scheme(d.key);
                return (year === +this.props.year && d.key === this.props.category) ? "#365f8d" : scheme(d.key)});
            // this.outlines[year].attr("d", line);
        }

        this.xAxis.call(d3.axisBottom(xScale).tickFormat(x => x));
        this.categorylabel.attr("x", width - margin.right - margin.left - 14);
    }

    createStackedArea() {
        if ('data' in this.state) {
            var fader = function(color) { return d3.interpolateRgb(color, "#fff")(0.1); };

            let scheme = d3.scaleOrdinal([d3.interpolateViridis(0.45), d3.interpolateViridis(0.525), d3.interpolateViridis(0.6), d3.interpolateViridis(0.675), d3.interpolateViridis(0.75), d3.interpolateViridis(0.75)].map(fader));

            const svg = d3.select(this.node);
            const height = this.props.height;
            const width = this.props.width;
            let margin = {top: 20, right: 50, bottom: 30, left: 50};

            const yScale = d3.scaleLinear().domain([0, maxvalue[this.props.city]]).range([height - margin.top - margin.bottom, 0]);
            const xScale = d3.scaleLinear().domain([minyear[this.props.city], maxyear[this.props.city]+1]).range([0, width - margin.left - margin.right]);
            this.g = svg.selectAll("g").data([1]).enter().append("g").attr("id", "maing").attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            this.areas = {};
            this.outlines = {};

            for (let year = minyear[this.props.city]; year < maxyear[this.props.city]; year++) {
                let stack = d3.stack().keys(categories[this.props.city]);
                let filtered = JSON.parse(JSON.stringify(this.state.data.filter((d) => d.year === year || d.year === year + 1 || d.year === year - 1)));
                let mode = 'real';
                
                if (year === minyear[this.props.city]) {
                    for (let key in filtered[0]) {
                        filtered[1][key] = (filtered[0][key] + filtered[1][key])/2;
                    }
                } else if (year < (maxyear[this.props.city]-1)) {
                    if (year === 2002 && this.props.city === "auckland") {
                        for (let key in filtered[0]) {
                            filtered[0][key] = (filtered[0][key] + filtered[1][key])/2;
                            if (key !== "Unknown" && key !== "year" && key !== "Total") filtered[2][key] = 0;
                        }

                        filtered[2]["Unknown"] = (filtered[1]["Total"] + filtered[2]["Total"])/2;
                        filtered[2]["year"] = (filtered[1]["year"] + filtered[2]["year"])/2;

                    } else if (year === 2003 && this.props.city === "auckland") {
                        for (let key in filtered[0]) {
                            filtered[0][key] = (filtered[0][key] + filtered[1][key])/2;
                            filtered[2][key] = (filtered[1][key] + filtered[2][key])/2;
                        }

                        for (let key in filtered[0]) {
                            if (key !== "year") {
                                filtered[0][key] = (filtered[1][key] / filtered[1].Total) * filtered[0].Total;
                            }
                        }
                    } else {
                        for (let key in filtered[0]) {
                            filtered[0][key] = (filtered[0][key] + filtered[1][key])/2;
                            filtered[2][key] = (filtered[1][key] + filtered[2][key])/2;
                        }
                    }
                } else {
                    for (let key in filtered[0]) {
                        filtered[0][key] = (filtered[0][key] + filtered[1][key])/2;
                    }

                    filtered = filtered.slice(0,2);
                    mode = 'estimated';
                }

                let stackedData = stack(filtered);

                let area = d3.area()
                    .x((d) => xScale(d.data.year))
                    .y0((d) => yScale(d[0]))
                    .y1((d) => yScale(d[1]));

                let line = d3.line()
                    .x((d) => xScale(d.data.year))
                    .y((d) => yScale(d[1]));

                this.categories = this.g.append("g").selectAll(".categories")
                    .data(stackedData)
                    .enter().append("g")
                        .attr("class", "categories");

                this.areas[year] = this.categories.append("path")
                    .attr("class", "area")
                    .attr("d", d => area(d))
                    .style("fill", (d) => {
                        let year = Math.round((d[0].data.year + d[1].data.year)/2);
                        scheme(d.key);
                        return (year === +this.props.year && d.key === this.props.category) ? "#365f8d" : scheme(d.key)})
                    .style("stroke", (d) => {
                        let year = Math.round((d[0].data.year + d[1].data.year)/2);
                        scheme(d.key);
                        return (year === +this.props.year && d.key === this.props.category) ? "#365f8d" : scheme(d.key)})
                    .style("stroke-width", "1px")
                    .on("click", this.handleMouseClick.bind(this));

                // this.outlines[year] = this.categories.append("path")
                //     .attr("class", "area")
                //     .attr("d", (d) => line(d))
                //     .style("stroke", "white")
                //     .style("fill", "none")
                //     .attr("stroke-width", 2)
                //     .attr("stroke-dasharray", mode === 'estimated' ? '3,3' : ',');
            }

            if (d3.selectAll(".categorylabel")._groups[0].length === 0) {
                this.categorylabel = this.categories.append("text")
                    .attr("class", "categorylabel")
                    .attr("x", width - margin.right - margin.left - 14)
                    .attr("y", function(d) { return yScale((d[d.length - 1][0] + d[d.length - 1][1]) / 2); })
                    .attr("dy", ".35em")
                    // .style("fill", "white")
                    .style("font-size", "14px")
                    .style("text-anchor", "end")
                    .text((d) => d.key==="Unknown" ? "" : d.key );
            }

            if (d3.selectAll(".axis--x")._groups[0].length == 0) {
                this.xAxis = this.g.append("g")
                    .attr("class", "axis axis--x")
                    .attr("transform", "translate(0," + (height - margin.bottom - margin.top) + ")")
                    .call(d3.axisBottom(xScale).tickFormat(x => x));
            }
          
            if (d3.selectAll(".axis--y")._groups[0].length == 0) {
                this.g.append("g")
                    .attr("class", "axis axis--y")
                    .call(d3.axisLeft(yScale).ticks(10));
            }
        }
    }

    render() {
        return <svg ref={node => this.node = node}
            width={this.props.width} height={this.props.height}>
            </svg>
    }
}

class Treemap extends Component {
    constructor(props) {
        super(props);
        this.state = {};

        d3.json("data/national/" + this.props.city + "/everything.json").then((data) => {
            this.setState({data: data});
        });
    }

    componentDidMount() {
        this.createTreeMap();
    }

    shouldComponentUpdate(newProps, newState) {
        if (newProps.city !== this.props.city) {
            d3.select(this.node).selectAll("g").remove();
            delete this.state.data;
            d3.json("data/national/" + newProps.city + "/everything.json").then((data) => {
                this.setState({data: data});
            });
            return false;
        }

        return true;
    }

    componentDidUpdate() {
        const l = d3.select(this.node).selectAll("g")._groups[0].length;
        if (l > 0) {
            this.updateTreeMap();
        } else {
            this.createTreeMap();
        }
    }

    updateTreeMap() {
        this.transitionTreeMap(this.props.category);
    }

    createTreeMap() {
        if ('data' in this.state) {
            const svg = d3.select(this.node);
            const width = svg.attr('width') - 50;
            const height = svg.attr('height');
            var format = d3.format(",d");
            var fader = function(color) { return d3.interpolateRgb(color, "#fff")(0.1); };
            var color = d3.scaleOrdinal(["#E4D024", "#BDD414", "#48C16E", "#2DBCBC", "#228D8D", "#6380A6", "#CD83A8", "#BE63AC", "#9B5DB6", "#5D6CBB"].map(fader));
                    
            var treemap = d3.treemap()
                .tile(d3.treemapResquarify)
                .size([width, height])
                .paddingInner(1)
                .round(true);

            var root = d3.hierarchy(this.state.data)
                .sum((d) => { return (d[this.props.year + '-' + this.props.category] || 0); });

            treemap(root);

            var cell = svg.selectAll("g")
                .data(root.leaves())
                .enter().append("g")
                .attr("transform", function(d) { return "translate(" + (d.x0 + 50) + "," + d.y0 + ")"; });

            cell.append("rect")
                .attr("id", function(d) { return d.data.name.replace(/[^a-zA-Z0-9]/g,'_'); })
                .attr("width", function(d) { return (d.x1 - d.x0) || 0; })
                .attr("height", function(d) { return (d.y1 - d.y0) || 0; })
                .attr("fill", function(d) { return color(d.parent.data.name); });

            cell.append("clipPath")
                .attr("id", function(d) { return "clip-" + d.data.name.replace(/[^a-zA-Z0-9]/g,'_'); })
                .append("use")
                .attr("xlink:href", function(d) { return "#" + d.data.name.replace(/[^a-zA-Z0-9]/g,'_'); });

            cell.append("text")
                .attr("clip-path", function(d) { return "url(#clip-" + d.data.name.replace(/[^a-zA-Z0-9]/g,'_') + ")"; })
                .attr("class", "treemap-label")
                .selectAll("tspan")
                .data(d => {return d.data.name.split(/(?=[A-Z][^A-Z])/g);})
                .enter().append("tspan")
                .attr("x", 4)
                .attr("y", function(d, i) { return 13 + i * 12; })
                .text(function(d) { return d; });

            cell.append("title")
                .text(function(d) { return d.data.name + "\n" + format(d.value); });

            this.transitionTreeMap = () => {
                treemap = treemap.size([this.props.width-50, height])

                treemap(root.sum((d) => (d[this.props.year + '-' + this.props.category] || 0)));

                cell.transition()
                    .duration(750)
                    .attr("transform", function(d) { return "translate(" + (d.x0 + 50) + "," + d.y0 + ")"; })
                .select("rect")
                    .attr("width", function(d) { return (d.x1 - d.x0) || 0; })
                    .attr("height", function(d) { return (d.y1 - d.y0) || 0; });

                cell.select("title")
                    .text(function(d) { return d.data.name + "\n" + format(d.value); });
            }
        }
    }

    render() {
        let title = ""
        if (this.props.city === "auckland") {
            title = "Origin of immigrants on " + this.props.category.toLowerCase() + " visas in " + this.props.year;
            if (this.props.category === "Unknown") title = "Origin of immigrants in " + this.props.year;
        } else {
            title = "Origin of " + this.props.category.toLowerCase() + " immigrants in " + this.props.year;
            if (this.props.category === "Other") title = "Origin of all other immigrants in " + this.props.year;
        }

        let country = "";
        if (this.props.city === "auckland") country = "New Zealand";
        if (this.props.city === "sydney") country = "Australia";
        if (this.props.city === "vancouver") country = "Canada";

        return <React.Fragment>
                <div className="area-title">
                    {"Permanent immigration to " + country + " by category, " + minyear[this.props.city] + "-" + (maxyear[this.props.city] - 1)}
                </div>
                <StackedArea update={this.props.update} width={this.props.width} height={400} city={this.props.city} year={this.props.year} category={this.props.category} />
                <div className="treemap-title">
                    {title}
                </div>
                <svg ref={node => this.node = node}
            width={this.props.width} height={this.props.height}></svg>
            </React.Fragment>
    }
}

export default Treemap


// WEBPACK FOOTER //
// ./src/Treemap/Treemap.js